import { useState, useRef } from "react";
const { board } = window.miro;

function ClearOrFill({ boardSelection }) {
  const [clearFillText, setClearFillText] = useState("");
  const [clearFillTextItems, setClearFillTextItems] = useState([]);
  const [toolOpen, setToolOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");

  const content = useRef(null);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content?.current?.scrollHeight}px`);
  }

  const clearFillTypeIcons = (
    <div className="cs5 ce12 grid">
      <div className="m2 icon icon-rectangle cs1"></div>
      <div className="m2 icon icon-sticky-bulk cs2"></div>
    </div>
  );

  async function runSelectItemsForClearFill(selection) {
    if (!selection) {
      return [];
    }
    if (selection.length === 0) {
      setClearFillTextItems(selection);
      return selection;
    }
    if (selection.length > 0) {
      let filteredSelection = selection.filter(
        (item) =>
          item.type === "sticky_note" ||
          item.type === "shape" ||
          item.type === "text"
      );

      setClearFillTextItems(filteredSelection);
      return filteredSelection;
    }
  }

  async function handleClearFill(flag) {
    let selection = await board.getSelection();
    let filteredSelection = await runSelectItemsForClearFill(selection);
    filteredSelection.forEach((item) => {
      if (flag === "clear") {
        item.content = "";
        item.sync();
      } else if (flag === "fill") {
        item.content = clearFillText;
        item.sync();
      }
    });
  }

  return (
    <div id="clear-or-fill-tool" className="grid tool-section mt-0 pb-0">
      <div
        id="clear-or-fill-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="cs1 mb-0 icon m2 icon-eraser"></div>
        <div className="cs2 ce11 h3 mb-0">Fill or Clear</div>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? " icon-arrow-right" : " icon-arrow-down")
          }></div>
      </div>

      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion">
        <div id="accordion-margin" className="cs1 ce12 grid mb-8">
          {/* <div className="cs1 ce12 p-medium mt-0">
            Fill a selection with chosen text, or clear that selection of all
            text.
          </div> */}
          <div
            id="clear-fill-works-on"
            className="help-container grid cs1 ce12 mt-0 mb-8 pt-8">
            <p className="p-small cs1 ce4 mb-0 mt-0">
              Works on <b>many:</b>
            </p>
            {clearFillTypeIcons}
          </div>

          <div className="cs1 ce9 form-group mb-0 mt-0">
            {/* <label>Split on:</label> */}
            <input
              onChange={(e) => setClearFillText(e.target.value)}
              className="input input-small mt-0"
              type="text"
              placeholder="Enter text to put in each item."
            />
          </div>

          <button
            type="button"
            className="button button-primary button-small cs10 ce12 mb-0 mt-0 mr-0"
            onClick={() => handleClearFill("fill")}>
            Fill
          </button>
          <button
            type="button"
            className="button button-primary button-small cs1 ce12 mb-0 mt-0"
            onClick={() => handleClearFill("clear")}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}

export default ClearOrFill;
